import { render, staticRenderFns } from "./view-master-login.vue?vue&type=template&id=21f4552a&scoped=true&"
import script from "./view-master-login.vue?vue&type=script&lang=js&"
export * from "./view-master-login.vue?vue&type=script&lang=js&"
import style0 from "./view-master-login.vue?vue&type=style&index=0&id=21f4552a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4552a",
  null
  
)

export default component.exports